import { create } from 'zustand';

export interface MonsterDot { id: number; tplId: number; x: number; y: number }

interface FieldState {
  monsters: MonsterDot[];
  setMonsters: (monsters: MonsterDot[]) => void;
}

export const useFieldStore = create<FieldState>((set) => ({
  monsters: [],
  setMonsters: (monsters) => set({ monsters }),
}));
